module.exports = __webpack_public_path__ + "img/fuxuankuang.ba0454f6.svg";